import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  return <section className="py-20 bg-brand-card/20" data-id="element-229">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-230">
        <div className="text-center mb-16" data-id="element-231">
          <span className="inline-block px-4 py-1 bg-white/5 border border-white/10 rounded-full text-brand-gold text-sm font-bold tracking-wider mb-4" data-id="element-232">
            +500 MUJERES RECUPERARON SU CABELLO
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white" data-id="element-233">
            Los folículos no mienten.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-234">
          {/* Testimonial 1 */}
          <div className="bg-black/40 p-6 rounded-lg border border-white/5 relative" data-id="element-235">
            <QuoteIcon className="absolute top-4 right-4 text-brand-gold/20 w-8 h-8" data-id="element-236" />
            <div className="flex text-brand-gold mb-3" data-id="element-237">
              <StarIcon className="w-3 h-3 fill-brand-gold" data-id="element-238" />
              <StarIcon className="w-3 h-3 fill-brand-gold" data-id="element-239" />
              <StarIcon className="w-3 h-3 fill-brand-gold" data-id="element-240" />
              <StarIcon className="w-3 h-3 fill-brand-gold" data-id="element-241" />
              <StarIcon className="w-3 h-3 fill-brand-gold" data-id="element-242" />
            </div>
            <p className="text-gray-300 font-light text-sm italic mb-4 leading-relaxed" data-id="element-243">
              "Llevaba 2 años usando minoxidil. Mi pelo era un estropajo,
              grasoso y me picaba horrores. Al dejarlo, se me cayó la mitad del
              cabello. Empecé el Protocolo con miedo. Al día 8 noté que al
              ducharme, la rejilla estaba limpia. Al mes, tengo pelitos nuevos
              asomando. Es un milagro barato y real."
            </p>
            <div className="flex items-center gap-3 mt-auto" data-id="element-244">
              <div className="w-10 h-10 rounded-full bg-brand-dark flex items-center justify-center border border-brand-gold/30 text-white font-bold text-sm" data-id="element-245">
                MV
              </div>
              <div data-id="element-246">
                <p className="text-white text-sm font-bold" data-id="element-247">María V.</p>
                <p className="text-xs text-gray-500" data-id="element-248">Compradora Verificada</p>
              </div>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-black/40 p-6 rounded-lg border border-white/5 relative" data-id="element-249">
            <QuoteIcon className="absolute top-4 right-4 text-brand-gold/20 w-8 h-8" data-id="element-250" />
            <div className="flex text-brand-gold mb-3" data-id="element-251">
              <StarIcon className="w-3 h-3 fill-brand-gold" data-id="element-252" />
              <StarIcon className="w-3 h-3 fill-brand-gold" data-id="element-253" />
              <StarIcon className="w-3 h-3 fill-brand-gold" data-id="element-254" />
              <StarIcon className="w-3 h-3 fill-brand-gold" data-id="element-255" />
              <StarIcon className="w-3 h-3 fill-brand-gold" data-id="element-256" />
            </div>
            <p className="text-gray-300 font-light text-sm italic mb-4 leading-relaxed" data-id="element-257">
              "El calorcito que se siente al aplicar el tónico es adictivo.
              Literalmente sientes cómo la sangre vuelve a tu cabeza. Llevo 14
              días exactos y las 'entradas' que me acomplejaban están
              cubriéndose de una sombra oscura de cabello nuevo. Gracias
              Carmen."
            </p>
            <div className="flex items-center gap-3 mt-auto" data-id="element-258">
              <div className="w-10 h-10 rounded-full bg-brand-dark flex items-center justify-center border border-brand-gold/30 text-white font-bold text-sm" data-id="element-259">
                SL
              </div>
              <div data-id="element-260">
                <p className="text-white text-sm font-bold" data-id="element-261">Sara L.</p>
                <p className="text-xs text-gray-500" data-id="element-262">Compradora Verificada</p>
              </div>
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-black/40 p-6 rounded-lg border border-white/5 relative" data-id="element-263">
            <QuoteIcon className="absolute top-4 right-4 text-brand-gold/20 w-8 h-8" data-id="element-264" />
            <div className="flex text-brand-gold mb-3" data-id="element-265">
              <StarIcon className="w-3 h-3 fill-brand-gold" data-id="element-266" />
              <StarIcon className="w-3 h-3 fill-brand-gold" data-id="element-267" />
              <StarIcon className="w-3 h-3 fill-brand-gold" data-id="element-268" />
              <StarIcon className="w-3 h-3 fill-brand-gold" data-id="element-269" />
              <StarIcon className="w-3 h-3 fill-brand-gold" data-id="element-270" />
            </div>
            <p className="text-gray-300 font-light text-sm italic mb-4 leading-relaxed" data-id="element-271">
              "Estaba ahorrando para un plasma capilar de 800 dólares. Me crucé
              con esto y por el precio de un café decidí probar. La preparación
              toma 5 minutos. El resultado en 3 semanas es mejor que todos los
              champús carísimos que compré el año pasado."
            </p>
            <div className="flex items-center gap-3 mt-auto" data-id="element-272">
              <div className="w-10 h-10 rounded-full bg-brand-dark flex items-center justify-center border border-brand-gold/30 text-white font-bold text-sm" data-id="element-273">
                AR
              </div>
              <div data-id="element-274">
                <p className="text-white text-sm font-bold" data-id="element-275">Ana R.</p>
                <p className="text-xs text-gray-500" data-id="element-276">Compradora Verificada</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}